import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
  // PayWall,
  // PayWallContent,
  // GroupInformation,
  // Title,
  // ImageWrapper,
  // Image,
  // Price,
  // Frecuency,
  // DesktopOwner,
  // MobileOwner,
  // SuscriptionEnded,
  // ExternalLink
  Flex,
  NewPaywallContainer,
  AuthorImage,
  TextWrapper,
  Subtitle,
  Author,
  CTAButton,
  GroupName,
} from "./styles";
import dateHandler from "../../../../helpers/dates-hanlder";
import constants from "../../../../constants";
import { DiscountDto, Group, PlanDto } from "../../../../types";
import Loader from "../../../../components/Loader";
import Clock from "../../../../components/Clock";
import { getGroupBySlug } from "../../../../store/actions/group";
import Link from "../../../../components/Link";
import openLink from "../../../../assets/icons/arrow-foward.svg";
import Icon from "../../../../components/Icon";
import UserRoundedIcon from "../../../../assets/icons/user-rounded.svg";
import { getCurrencyFromLocation } from "../../../../helpers/location";
import { useWindowSize } from "../../../../hooks/useWindowSize";

export interface ComponentProps {
  postSlug: string;
  group: Group;
}

export const Component = ({ postSlug, group }: ComponentProps) => {
  const [inscriptionEnded, setInscriptionEnded] = useState<boolean>();
  const [selectedCurrency, setSelectedCurrency] = useState<string | null>(null);
  const [monthlyPlan, setMonthyPlan] = useState<PlanDto | undefined>(undefined);
  const [monthlyPlanDiscount, setMonthlyPlanDiscount] = useState<
    DiscountDto | undefined
  >(undefined);
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize()

  const getCurrency = () => {
    if (monthlyPlan?.currency) {
      return constants.currencies.filter(
        (currency) => currency?.iso === monthlyPlan?.currency
      )[0].label;
    }
  };

  useEffect(() => {
    !!postSlug && dispatch(getGroupBySlug(postSlug));
  }, [postSlug]);

  useEffect(() => {
    const fetchCurrencyAndSet = async () => {
      if (!!group?.plans && group?.plans.filter((p) => p.status === "active").length > 0) {
        try {
          const currency = await getCurrencyFromLocation();

          if (!currency) {
            setSelectedCurrency(group?.main_currency);
          } else {
            const currencyPriorities = {
              EUR: ["EUR", "USD", "ARS"],
              USD: ["USD", "EUR", "ARS"],
              ARS: ["ARS", "USD", "EUR"],
            };

            for (const tmpCurrency of currencyPriorities[currency || group?.main_currency]) {
              // Check if there are active plans with the current tmpCurrency
              const activePlans = group.plans.filter(
                (p) => p.status === "active" && p.currency === tmpCurrency
              );

              if (activePlans.length > 0) {
                // Set the selected currency and break the loop
                setSelectedCurrency(tmpCurrency);
                break;
              }
            }
          }
        } catch (error) {
          console.error("Error fetching currency:", error);
        }
      }
    };

    fetchCurrencyAndSet();
  }, [group]);

  useEffect(() => {
    const isMembership = group?.group_type === "membership";
    const isExperience = group?.group_type === "experience";
    setMonthyPlan(
      group?.plans?.filter(
        (plan) =>
          (isMembership && plan.period_unit === "month" && plan.currency === selectedCurrency) ||
          (isExperience && !plan.period_unit)
      )[0]
    );
  }, [group, selectedCurrency]);

  useEffect(() => {
    if (monthlyPlan?.discounts)
      setMonthlyPlanDiscount(monthlyPlan?.discounts[0]);
  }, [monthlyPlan]);

  if (!group) {
    return <Loader />;
  }


  return (

    <NewPaywallContainer>
      <Flex>
        <AuthorImage
          src={group?.profile_pic?.url || group?.expert?.profile_pic?.url  || UserRoundedIcon}
          onError={(event) => (event.currentTarget.src = UserRoundedIcon)}
          alt={group.creator_name}
        />
        <TextWrapper>
          <Subtitle>Este contenido pertenece a</Subtitle>
          <GroupName>{group.group_name}</GroupName>
          <div style={{ height: isMobile ? 6 : 12 }} />
          <Author>Por {group.creator_name}</Author>
        </TextWrapper>
      </Flex>

      {!dateHandler.isExpired(group.registration_closing_date) ? (
        <CTAButton
          href={`/group/${group?.slug}?scrollTo=price`}
          target="_blank"
        >
          Inscribirme
          <Icon
            icon={openLink}
            size="24px"
            color="white"
          />
        </CTAButton>
      ) : group?.waiting_list_external_url ? (
        <CTAButton
          href={group.waiting_list_external_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {group.waiting_list_cta_text?.trim() || "Reservar mi lugar"}
          <Icon
            icon={openLink}
            size="24px"
            color="white"
          />
        </CTAButton>
      ) : (
        <CTAButton
          href="#"
        >
          Inscripciones cerradas
        </CTAButton>
      )}
    </NewPaywallContainer>
    // <PayWall>
    //   <PayWallContent>
    //     <ImageWrapper>
    //       <Image
    //         src={group?.cover_pic?.url || backgrounds[randomBg]}
    //         onError={(event) =>
    //           (event.currentTarget.src = backgrounds[randomBg])
    //         }
    //       />
    //     </ImageWrapper>

    //     <GroupInformation>
    //       <DesktopOwner>
    //         Este contenido pertenece{" "}
    //         {group?.group_type === "membership"
    //           ? "a la membresía de"
    //           : "al taller de"}{" "}
    //         <strong>{group?.creator_name}</strong>
    //       </DesktopOwner>

    //       <MobileOwner>
    //         {group?.group_type === "membership" ? "Membresía" : group?.group_type === "experience" ? "Taller" : "Evento"} de{" "}
    //         <strong>{group?.creator_name}</strong>
    //       </MobileOwner>

    //       <Price withDiscount={!!monthlyPlanDiscount}>
    //         {getCurrency()}{" "}
    //         {monthlyPlan?.discounts && monthlyPlan?.discounts.length > 0
    //           ? (monthlyPlan?.price || 0) -
    //           (monthlyPlan?.discounts[0].amount || 0)
    //           : monthlyPlan?.price}
    //       </Price>

    //       <Frecuency>
    //         {group?.group_type === "membership" ? "por mes" : group?.group_type === "experience" ? "un pago" : "¡Es gratis!"}
    //       </Frecuency>




    //       {!!group.registration_closing_date && (
    //         <>
    //           {!dateHandler.isExpired(group.registration_closing_date) ? (
    //             <Clock
    //               style={{ marginTop: "6px" }}
    //               date={group.registration_closing_date}
    //               onEnd={() => window.location.reload()}
    //               type="string"
    //               prefix="Las inscripciones cierran en"
    //             />
    //           ) : (
    //             <SuscriptionEnded>Inscripciones cerradas</SuscriptionEnded>
    //           )}
    //         </>
    //       )}
    //     </GroupInformation>
    //   </PayWallContent>
    // </PayWall>
  );
};

const state = ({ groupStore }) => {
  const { data: group } = groupStore.group;
  return { group };
};

export default connect(state)(Component);
